import io from 'socket.io-client'
import log from './log'
import {env} from '@lib'

const server = new URL(window.location.origin)

if (env.io?.port)
	server.port = env.io.port

log.push('status', 'Connecting to remi backend...')
export const socket = io(server.toString())

socket.on('error', e => {
	log.push('error', JSON.stringify(e))
	console.error(e)
})

socket.on('connect_error', e => {
	log.push('error', JSON.stringify(e))
	console.error(e)
})

socket.on('disconnect', reason => {
	log.push('status', 'remi backend disconnected: ' + reason)
})

socket.on('data', data => log.push('vMix', data))
socket.on('status', status => log.push('status', status))

